import { render, staticRenderFns } from "./CampaignQueueComponent.vue?vue&type=template&id=0fafc5b6&"
import script from "./CampaignQueueComponent.vue?vue&type=script&lang=js&"
export * from "./CampaignQueueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports